// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","489":"49b2486b","532":"styles","678":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"57":"b54172ebe7445f860136","351":"03620a4571b347786325","489":"9bd3ee42ec18323d6454","532":"710436557fbf9d3139fa","678":"2de8f5b21c560bcf6194"}[chunkId] + ".js";
};